export const toHex = (n: number): string => n.toString(16).padStart(2, '0');

export const rgbToHex = (r: number, g: number, b: number): string =>
  `#${toHex(r)}${toHex(g)}${toHex(b)}`;

export const hexToRgb = (hex: string): {r: number; g: number; b: number} => {
  const clean = hex.replace('#', '');
  return {
    r: parseInt(clean.slice(0, 2), 16) || 0,
    g: parseInt(clean.slice(2, 4), 16) || 0,
    b: parseInt(clean.slice(4, 6), 16) || 0,
  };
};

const colorConverter = {rgbToHex, hexToRgb};
export default colorConverter;
